<template>
  <div class="row">
    <div class="col-md-12 card card-wizard">
      <div class="card-header">
        <div class="text-center">
        </div>
        <h4 class="title text-center">Observaciones y/o Aclaraciones.</h4>
      </div>
      <div class="card-content">
        <textarea v-model="model.comentarios" class="form-control" row="15" placeholder="Éste campo es opcional.">

            </textarea>
      </div>
      <div class="col-md-6 col-md-offset-3 container-fluid text-center">
        <button type="button" class="btn btn-wd btn-success" @click="guardar">
          <span class="btn-label">
            <i class="fa fa-save"></i>
          </span>
          Guardar y Continuar
        </button>
        <br><br><br><br>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    Table,
    TableColumn
  } from 'element-ui'
  Vue.use(Table)
  Vue.use(TableColumn)
  export default {
    data() {
      return {
        ip_id: null,
        model: {}
      }
    },
    created() {
      this.checkPermissions()
      this.ip_id = this.getId();

    },
    watch: {
    '$route': 'checkPermissions'
    },
    methods:{  
        checkPermissions() {
            if(!(this.getKey('role')==0 && this.getKey('status_dec') == 1))
            {
               localStorage.clear();                                             
               this.$router.push('/login'); 
               this.$router.go();
       
            }
      },
      guardar() {
        this.$http.post('observaciones', this.model).then(
          response => {
            this.$router.push("resumen");
          },
          error => {
            this.StepError(error);
            //console.log(error);
          })
      }
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Observaciones.vue